declare namespace $ {

	export class $mol_icon_language_html5 extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=html5.view.tree.d.ts.map